import { Injectable } from '@angular/core';
import * as DOMPurify from 'dompurify';
import { marked } from 'marked';

@Injectable({ providedIn: 'root' })
export class MarkdownService {
  public parse(html: string): string {
    return DOMPurify.sanitize(marked.parse(html));
  }
}
